    /**
     * 获取资源问答emdding进度等信息
     */
    API.reqResoureProcess = (data) => ajax.get(`/terminator/api/v1/application/chat/resource_precheck`, data)
    /**
     * 获取frameID
     */
    API.reqQaList = (data) => ajax.get(`/terminator/api/v1/application/chat`, data)